import { Component, ComponentProps } from 'react'
import { connect } from 'react-redux'
import * as styles from 'styles/pages/Onboarding.css'
import { State } from 'interfaces/state'
import { isMobileSelector } from 'selectors/viewportSelectors'
import CommonLayout from 'components/layouts/CommonLayout'
import { IS_STATUS_APP } from 'helpers/userAgentHelpers'
import ProgressBar from 'components/atoms/ProgressBar/ProgressBar'

type OnboardingStateProps = {
  isMobile: boolean
}

type OnboardingOwnProps =
  & ComponentProps<typeof ProgressBar>
  & {
  }

type OnboardingProps =
  & OnboardingStateProps
  & OnboardingOwnProps

class OnboardingComponent extends Component<OnboardingProps> {
  render () {
    const {
      children,
      isMobile,
      progressPercent = null,
    } = this.props

    const headerChild = IS_STATUS_APP
      ? (
        <header />
      )
      : null

    return (
      <CommonLayout header={ headerChild } logoSize='responsive-small'>
        { isMobile && !!progressPercent && (
          <div className={ styles.profileCompact }>
            <ProgressBar progressPercent={ progressPercent } />
          </div>
        )}
        <main className={ styles.main }>
          { children }
        </main>
      </CommonLayout>
    )
  }
}

const mapStateToProps = (state: State): OnboardingStateProps => {
  return {
    isMobile: isMobileSelector(state),
  }
}

const Onboarding = connect<OnboardingStateProps, {}, OnboardingOwnProps>(mapStateToProps)(OnboardingComponent)
export default Onboarding
